import type { Staat } from '../../gedeeld/types'

/* Hoe tijden, duur en getallen eruitzien. Overal hetzelfde. */

const volledig = new Intl.DateTimeFormat('nl-NL', { day: 'numeric', month: 'short', hour: '2-digit', minute: '2-digit' })
const metSeconden = new Intl.DateTimeFormat('nl-NL', { day: 'numeric', month: 'short', hour: '2-digit', minute: '2-digit', second: '2-digit' })
const tijd = new Intl.DateTimeFormat('nl-NL', { hour: '2-digit', minute: '2-digit' })
const dag = new Intl.DateTimeFormat('nl-NL', { weekday: 'short', day: 'numeric', month: 'short' })

export const datumTijd = (t: number | null | undefined) => (t ? volledig.format(new Date(t)) : '')
export const precies = (t: number | null | undefined) => (t ? metSeconden.format(new Date(t)) : '')
export const kloktijd = (t: number) => tijd.format(new Date(t))
export const dagNaam = (t: number) => dag.format(new Date(t))

/** "zojuist", "12 s geleden", "4 min geleden", "3 uur geleden", of een datum. */
export function geleden(t: number | null | undefined, nu = Date.now()): string {
  if (!t) return 'nooit'
  const s = Math.round((nu - t) / 1000)
  if (s < 5) return 'zojuist'
  if (s < 60) return `${s} s geleden`
  if (s < 3600) return `${Math.round(s / 60)} min geleden`
  if (s < 86400) return `${Math.round(s / 3600)} uur geleden`
  if (s < 7 * 86400) return `${Math.round(s / 86400)} dagen geleden`
  return datumTijd(t)
}

/** Een tijdsduur: "40 s", "12 min", "3 uur 5 min", "2 dagen". */
export function duur(ms: number): string {
  const s = Math.round(ms / 1000)
  if (s < 60) return `${s} s`
  const m = Math.round(s / 60)
  if (m < 60) return `${m} min`
  const u = Math.floor(m / 60)
  if (u < 48) return m % 60 ? `${u} uur ${m % 60} min` : `${u} uur`
  return `${Math.round(u / 24)} dagen`
}

export const ms = (n: number | null | undefined) => (n === null || n === undefined ? '—' : n < 1000 ? `${n} ms` : `${(n / 1000).toFixed(1)} s`)

export function procent(d: number | null | undefined, cijfers = 2): string {
  if (d === null || d === undefined) return '—'
  if (d >= 1) return '100%'
  return `${(Math.floor(d * 10 ** (cijfers + 2)) / 10 ** cijfers).toFixed(cijfers)}%`
}

export function bytes(n: number | null | undefined): string {
  if (n === null || n === undefined) return '—'
  if (n < 1024) return `${n} B`
  if (n < 1024 ** 2) return `${(n / 1024).toFixed(1)} kB`
  if (n < 1024 ** 3) return `${(n / 1024 ** 2).toFixed(1)} MB`
  return `${(n / 1024 ** 3).toFixed(2)} GB`
}

export const getal = (n: number | null | undefined) => (n === null || n === undefined ? '—' : new Intl.NumberFormat('nl-NL').format(n))

export const STAAT_LABEL: Record<Staat, string> = {
  werkt: 'Werkt',
  traag: 'Traag of verstoord',
  storing: 'Storing',
  onbekend: 'Onbekend',
}

/** De volgorde waarin problemen bovenaan komen. */
export const STAAT_GEWICHT: Record<Staat, number> = { storing: 0, traag: 1, onbekend: 2, werkt: 3 }

export function initialen(naam: string | null | undefined): string {
  if (!naam) return '?'
  const delen = naam.trim().split(/\s+/).filter(Boolean)
  return ((delen[0]?.[0] ?? '?') + (delen.length > 1 ? delen[delen.length - 1]?.[0] ?? '' : '')).toUpperCase()
}

export const meervoud = (n: number, een: string, meer: string) => `${n} ${n === 1 ? een : meer}`
